const fares = {
  toast: {
    error: {
      badResponse: '[Fare] bad server response',
      create: {},
      edit: {},
    },
    success: {
      create: {
        default: '[Fare] Created Successfully',
      },
      edit: {},
      delete: {
        default: '[Fare] deleted successfully',
      },
    },
  },
  createFareBtn: 'Create',
  showBreakdownBtn: 'Show Breakdown',
  total: 'Total: ',

  deleteModal: {
    header: 'Delete Fares',
    body: 'You are about to delete {{num}} fares.',
  },

  table: {
    headers: {
      biDir: 'Bi Directional',
    },
    biDirOptions: {
      way2: '2-Way',
      way1: '1-Way',
    },
    actions: {
      delete: 'Delete',
      export: 'Export',
    },
  },

  fareTypeOptions: {
    Base: 'Base',
    Addition: 'Addition',
    Percent: 'Percent',
    Total: 'Total',
  },

  additions: {
    value: 'Value',
    valueType: 'Value Type',
    name: 'Name',
    hour1: 'Start Time',
    hour2: 'End Time',
    date1: 'Start Date',
    date2: 'End Date',
    cancel: 'Cancel',
    addAddition: 'Add Addition',
    priority: 'Priority',
    weekDays: 'Week Days',
    newAddition: 'New Addition',
    price: 'Price',
    total: 'Total',
    percent: 'Percent',
    columnExist: 'Title allready exists',
  },

  create: {
    confirmButtonText: 'Confirm',
    code: 'Code',
    from: 'From',
    to: 'To',
    service: 'Services',
    select: 'Select',
    validations: {
      code: 'Code is required',
    },

    successToast: {
      message: 'Success! Fare Created.',
    },
    errorToast: {
      message: 'Error Occurred! Could Not Create Fare',
    },
  },

  update: {
    code: 'Code',
    from: 'From',
    to: 'To',
    service: 'Services',
    price: 'Price',
    confirmButtonText: 'Update',
    successMsg: 'Fare updated successfully',

    successToast: {
      message: 'Success! Fare Updated successfully.',
    },
    errorToast: {
      message: 'Error Occurred! Could Not Update Fare',
    },
  },

  validations: {
    code: {
      require: 'Code is required',
    },
    from: {
      require: 'From is required',
    },
    to: {
      require: 'To is required',
    },
    service: {
      require: 'Service is required',
    },
    unit: {
      require: 'Unit is required',
    },
    rateType: {
      require: 'Rate type is required',
    },
  },
  forms: {
    header: {
      createFare: {
        title: 'Create',
      },

      updateFare: {
        title: 'Update',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Submit',
        update: 'Submit',
      },
    },

    information: {
      details: {
        header: 'Fare Details',
        fields: {
          units: {
            name: 'Sites',
          },
          name: {
            name: 'Name',
          },
          group: {
            name: 'Group',
          },
          services: {
            name: 'Services',
          },
          biDirectional: {
            name: 'Directional',
          },
          from: {
            name: 'From Zone',
          },
          to: {
            name: 'To Zone',
          },
        },
      },
      mileage: {
        header: 'Mileage',
        fields: {
          distanceFrom: {
            name: 'Distance From',
          },
          distanceTo: {
            name: 'Distance To',
          },
        },
      },
      conditions: {
        header: 'Conditions',
        fields: {
          startDate: {
            name: 'Start Date',
          },
          endDate: {
            name: 'End Date',
          },
          startHour: {
            name: 'Start Time',
          },
          endHour: {
            name: 'End Time',
          },
          weekDays: {
            name: 'Weekdays',
          },
          fromDate: {
            name: 'From Date',
          },
          toDate: {
            name: 'To Date',
          },
        },
      },
    },
  },
};

export default fares;
